import { navigation } from "./navigation";

export const useRouter = navigation.useRouter;
